var map = {
	"./artpm.png": "0fc0",
	"./byd-logo-mobile.png": "e864",
	"./byd-logo.png": "cbcd",
	"./chery-logo-mobile.png": "bd1f",
	"./chery-logo.png": "f7e2",
	"./ford-logo-mobile.png": "56d1",
	"./ford-logo.png": "e314",
	"./mg-logo-mobile.png": "39b0",
	"./mg-logo.png": "3fbd",
	"./oj-logo-mobile.png": "476b",
	"./oj-logo.png": "3464"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";